<template>
  <div class="route_container">
    <div class="container-fluid mt-5 px-0">
      <div class="container py-5">
        <div class="d-flex flex-lg-row flex-column mt-3">
          <div class="col-lg-3 filter-column pr-md-3 px-0">
            <div>
              <ul
                id="dashboardList"
                class="nav nav-tabs accordion d-flex flex-column flex-nowrap bg-gray-900 border-green-lighter box-shadow mt-3"
                role="tablist"
              >
                <li class="nav-item">
                  <a
                    id="category-tab"
                    class="nav-link active p-0"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="category"
                    aria-selected="true"
                  >
                    <div
                      class="d-flex flex-row align-items-start justify-content-between p-md-3 py-2"
                    >
                      <div class="col-1">
                        <font-awesome-icon
                          :icon="{ prefix: 'fas', iconName: 'home' }"
                        />
                      </div>
                      <div
                        class="categories-title d-flex flex-column align-items-start col-11"
                      >
                        <p class="h6 mb-0">Dashboard</p>
                        <p class="d-sm-flex d-none mb-0">
                          Quick links and stats about your forum
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    id="general-tab"
                    class="nav-link p-0"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="general"
                    aria-selected="false"
                  >
                    <div
                      class="d-flex flex-row align-items-start justify-content-between p-md-3 py-2"
                    >
                      <div class="col-1">
                        <font-awesome-icon
                          :icon="{ prefix: 'fas', iconName: 'th' }"
                        />
                      </div>
                      <div
                        class="categories-title d-flex flex-column align-items-start col-11"
                      >
                        <p class="h6 mb-0">{{ $t('forum_general') }}</p>
                        <p class="d-sm-flex d-none mb-0">
                          Categories and settings
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    id="moderation-tab"
                    class="nav-link p-0"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="moderation"
                    aria-selected="false"
                  >
                    <div
                      class="d-flex flex-row align-items-start justify-content-between p-md-3 py-2"
                    >
                      <div class="col-1">
                        <font-awesome-icon
                          :icon="{
                            prefix: 'fas',
                            iconName: 'exclamation-circle',
                          }"
                        />
                      </div>
                      <div
                        class="categories-title d-flex flex-column align-items-start col-11"
                      >
                        <p class="h6 mb-0">Moderation</p>
                        <p class="d-sm-flex d-none mb-0">
                          View and respond to user reports
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    id="users-tab"
                    class="nav-link p-0"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="users"
                    aria-selected="false"
                  >
                    <div
                      class="d-flex flex-row align-items-start justify-content-between p-md-3 py-2"
                    >
                      <div class="col-1">
                        <font-awesome-icon
                          :icon="{ prefix: 'fas', iconName: 'user-circle' }"
                        />
                      </div>
                      <div
                        class="categories-title d-flex flex-column align-items-start col-11"
                      >
                        <p class="h6 mb-0">{{ $t('forum_users') }}</p>
                        <p class="d-sm-flex d-none mb-0">
                          View current user accounts and manage roles
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-9 pl-md-3 px-0 mt-3">
            <div class="col-12 p-0 d-flex flex-column tab-content mb-5">
              <div
                class="tab-pane fade show active"
                id="category"
                role="tabpanel"
                aria-labelledby="category-tab"
                v-show="isDashboard"
              >
                <div class="w-100 border-bottom border-green-lighter mb-3">
                  <h3 class="display-4">Dashboard</h3>
                </div>
                <div class="d-flex flex-row flex-wrap">
                  <div>
                    <div
                      data-v-8b815544=""
                      class="admin_dashboard__card admin_dashboard__card--3"
                    >
                      <div
                        data-v-8b815544=""
                        class="widgets__line_chart"
                        style="background-color: rgb(17 84 55)"
                      >
                  
                        <svg>
                          <g
                            transform="translate(30,0)"
                            class="widgets__line_chart__axis"
                            fill="none"
                            font-size="10"
                            font-family="sans-serif"
                            text-anchor="end"
                          >
                            <path
                              class="domain"
                              stroke="#000"
                              d="M-6,15.5H0.5V142.5H-6"
                            ></path>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,15.5)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">50</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,28.199999999999996)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">45</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,40.89999999999999)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">40</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,53.60000000000001)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">35</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,66.30000000000001)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">30</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,79)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">25</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,91.7)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">20</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,104.39999999999999)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">15</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,117.10000000000001)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">10</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,129.8)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">5</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,142.5)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">0</text>
                            </g>
                          </g>
                          <g
                            transform="translate(0,150)"
                            class="widgets__line_chart__axis widgets__line_chart__axis--x"
                            fill="none"
                            font-size="10"
                            font-family="sans-serif"
                            text-anchor="middle"
                          >
                            <path
                              class="domain"
                              stroke="#000"
                              d="M40.5,0V0.5H356.078125V0"
                            ></path>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(50.67993951612903,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Wed 07</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(71.03981854838709,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Fri 09</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(91.39969758064515,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Apr 11</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(111.75957661290323,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Tue 13</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(132.11945564516128,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Thu 15</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(152.47933467741936,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Sat 17</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(172.8392137096774,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Mon 19</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(193.1990927419355,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Wed 21</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(213.55897177419354,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Fri 23</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(233.91885080645164,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Apr 25</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(254.27872983870967,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Tue 27</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(274.63860887096774,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Thu 29</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(294.9984879032258,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">May</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(315.3583669354839,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Mon 03</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(335.7182459677419,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Wed 05</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(356.078125,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Fri 07</text>
                            </g>
                          </g>
                          <path
                            fill="none"
                            stroke-width="2"
                            stroke="#fff"
                            d="M40,134.38C40,134.38,46.374803673169176,35.416173131204935,50.17993951612903,35.32000000000001C53.29691685244441,35.241219771724346,55.631779525289474,85.27833826555013,60.359879032258064,101.35999999999999C63.25331247215313,111.20142101132964,66.95914939861191,117.16173452216519,70.53981854838709,124.22C73.77973799656715,130.60657486506142,76.49317444247984,139.5496048056608,80.71975806451613,142C83.69904212744241,143.72726343619547,87.87547359120045,143.61675509108176,90.89969758064515,142C94.95749373098776,139.83069554122443,97.17537737877639,127.79657871877393,101.07963709677418,126.75999999999999C104.15576873153239,125.94328881297558,107.79473411716741,130.56072223297355,111.25957661290323,131.84C114.58692477725498,133.06851256155227,118.59378935810406,136.41023888857984,121.43951612903226,134.38C130.9538902223002,127.59211984158652,126.63857786468442,17.735747569245458,131.61945564516128,17.540000000000003C136.73289178994105,17.339042911722146,128.5808325247493,120.09618184917402,151.97933467741936,139.46C174.25286382566023,157.89282810111166,228.50107029820572,137.32208633321116,263.9586693548387,136.92C296.02715038354785,136.5563459937631,355.578125,136.92,355.578125,136.92"
                          ></path>
                          <circle
                            cx="40"
                            cy="134.38"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="50.17993951612903"
                            cy="35.32000000000001"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="60.359879032258064"
                            cy="101.35999999999999"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="70.53981854838709"
                            cy="124.22"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="80.71975806451613"
                            cy="142"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="90.89969758064515"
                            cy="142"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="101.07963709677418"
                            cy="126.75999999999999"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="111.25957661290323"
                            cy="131.84"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="121.43951612903226"
                            cy="134.38"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="131.61945564516128"
                            cy="17.540000000000003"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="151.97933467741936"
                            cy="139.46"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="263.9586693548387"
                            cy="136.92"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="355.578125"
                            cy="136.92"
                            r="4"
                            fill="rgb(255, 237, 127)"
                          ></circle>
                          <circle
                            cx="40"
                            cy="134.38"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="50.17993951612903"
                            cy="35.32000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="60.359879032258064"
                            cy="101.35999999999999"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="70.53981854838709"
                            cy="124.22"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="80.71975806451613"
                            cy="142"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="90.89969758064515"
                            cy="142"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="101.07963709677418"
                            cy="126.75999999999999"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="111.25957661290323"
                            cy="131.84"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="121.43951612903226"
                            cy="134.38"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="131.61945564516128"
                            cy="17.540000000000003"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="151.97933467741936"
                            cy="139.46"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="263.9586693548387"
                            cy="136.92"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="355.578125"
                            cy="136.92"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                        </svg>
                      </div>
                      <div
                        data-v-8b815544=""
                        class="admin_dashboard__card__title"
                      >
                        {{ $t('forum_page_views_past_week') }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      data-v-8b815544=""
                      class="admin_dashboard__card admin_dashboard__card--2"
                    >
                      <div
                        data-v-7a6de205=""
                        data-v-8b815544=""
                        class="widgets__new_post"
                      >
                        <div data-v-7a6de205="" class="widgets__new_post__main">
                          No new posts
                        </div>
                        <div
                          data-v-7a6de205=""
                          class="widgets__new_post__message"
                        >
                          <svg
                            data-v-7a6de205=""
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fa"
                            data-icon="minus"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            class="svg-inline--fa fa-minus fa-w-14"
                          >
                            <path
                              data-v-7a6de205=""
                              fill="currentColor"
                              d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                            ></path>
                          </svg>
                          No change since yesterday
                        </div>
                      </div>
                      <div
                        data-v-8b815544=""
                        class="admin_dashboard__card__title"
                      >
                        {{ $t('forum_new_threads_24_hours') }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      data-v-8b815544=""
                      class="admin_dashboard__card admin_dashboard__card--2"
                    >
                      <div data-v-8b815544="" class="widgets__categories_chart">
                        <div
                          class="widgets__categories_chart__tooltip"
                          style="left: 0px; top: 0px"
                        ></div>
                        <div class="widgets__categories_chart__main">
                          <svg>
                            <g transform="translate(83.5, 83.5)">
                              <path
                                d="M4.500576986866523e-15,-73.5A73.5,73.5,0,1,1,-4.500576986866523e-15,73.5A73.5,73.5,0,1,1,4.500576986866523e-15,-73.5M-6.153850165715449e-15,-33.5A33.5,33.5,0,1,0,6.153850165715449e-15,33.5A33.5,33.5,0,1,0,-6.153850165715449e-15,-33.5Z"
                                data-index="0"
                                fill="#00ff7f"
                              ></path>
                              <path
                                d="M-1.3501730960599567e-14,-73.5L-6.153850165715449e-15,-33.5Z"
                                data-index="1"
                                fill="#314954"
                              ></path>
                              <text
                                data-index="0"
                                fill="#fff"
                                transform="translate(-4.9999999999999964,58.5)"
                              >
                                1
                              </text>
                              <text
                                data-index="1"
                                fill="#fff"
                                transform="translate(-5.00000000000001,-48.5)"
                              ></text>
                            </g>
                            <!---->
                          </svg>
                          <div class="widgets__categories_chart__main__legend">
                            <div class="widgets__categories_chart__title">
                              categories
                            </div>
                            <div class="widgets__categories_chart__label">
                              <div
                                class="widgets__categories_chart__label__square"
                                style="background-color: #00ff7f"
                              ></div>
                              General Discussion
                            </div>
                            <div class="widgets__categories_chart__label">
                              <div
                                class="widgets__categories_chart__label__square"
                                style="background-color: #314954"
                              ></div>
                              Hot Gameplay
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-v-8b815544=""
                        class="admin_dashboard__card__title"
                      >
                        {{ $t('forum_numbre_of_threads') }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      data-v-8b815544=""
                      class="admin_dashboard__card admin_dashboard__card--2"
                    >
                      <div
                        data-v-05035fe7=""
                        data-v-8b815544=""
                        class="widgets__top_posts"
                      >
                        <div
                          data-v-05035fe7=""
                          class="widgets__top_posts__item widgets__top_posts__item--0"
                        >
                          <div
                            data-v-05035fe7=""
                            class="widgets__top_posts__item__number"
                          >
                            1
                          </div>
                          <div
                            data-v-05035fe7=""
                            class="widgets__top_posts__item__info"
                          >
                            <div
                              data-v-05035fe7=""
                              class="widgets__top_posts__item__title"
                            >
                              Welcome
                            </div>
                            <div
                              data-v-05035fe7=""
                              class="widgets__top_posts__item__views"
                            >
                              1 page view
                            </div>
                          </div>
                        </div>
                        <div
                          data-v-05035fe7=""
                          class="widgets__top_posts__item widgets__top_posts__item--1"
                        >
                          <!---->
                          <div
                            data-v-05035fe7=""
                            class="widgets__top_posts__item__info"
                          >
                            <div
                              data-v-05035fe7=""
                              class="widgets__top_posts__item__title"
                            >
                              <!---->
                            </div>
                            <!---->
                          </div>
                        </div>
                        <div
                          data-v-05035fe7=""
                          class="widgets__top_posts__item widgets__top_posts__item--2"
                        >
                          <!---->
                          <div
                            data-v-05035fe7=""
                            class="widgets__top_posts__item__info"
                          >
                            <div
                              data-v-05035fe7=""
                              class="widgets__top_posts__item__title"
                            >
                              <!---->
                            </div>
                            <!---->
                          </div>
                        </div>
                        <div
                          data-v-05035fe7=""
                          class="widgets__top_posts__item widgets__top_posts__item--3"
                        >
                          <!---->
                          <div
                            data-v-05035fe7=""
                            class="widgets__top_posts__item__info"
                          >
                            <div
                              data-v-05035fe7=""
                              class="widgets__top_posts__item__title"
                            >
                              <!---->
                            </div>
                            <!---->
                          </div>
                        </div>
                      </div>
                      <div
                        data-v-8b815544=""
                        class="admin_dashboard__card__title"
                      >
                        {{ $t('forum_top_threads') }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      data-v-8b815544=""
                      class="admin_dashboard__card admin_dashboard__card--3"
                    >
                      <div
                        data-v-8b815544=""
                        class="widgets__line_chart"
                        style="background-color: rgb(10 103 89) ;"
                      >
                        <svg>
                          <g
                            transform="translate(30,0)"
                            class="widgets__line_chart__axis"
                            fill="none"
                            font-size="10"
                            font-family="sans-serif"
                            text-anchor="end"
                          >
                            <path
                              class="domain"
                              stroke="#000"
                              d="M-6,15.5H0.5V142.5H-6"
                            ></path>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,15.5)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">5.0</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,28.199999999999996)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">4.5</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,40.89999999999999)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">4.0</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,53.60000000000001)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">3.5</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,66.30000000000001)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">3.0</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,79)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">2.5</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,91.7)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">2.0</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,104.39999999999999)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">1.5</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,117.10000000000001)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">1.0</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,129.8)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">0.5</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(0,142.5)"
                            >
                              <line stroke="#000" x2="-6"></line>
                              <text fill="#000" x="-9" dy="0.32em">0.0</text>
                            </g>
                          </g>
                          <g
                            transform="translate(0,150)"
                            class="widgets__line_chart__axis widgets__line_chart__axis--x"
                            fill="none"
                            font-size="10"
                            font-family="sans-serif"
                            text-anchor="middle"
                          >
                            <path
                              class="domain"
                              stroke="#000"
                              d="M40.5,0V0.5H305.265625V0"
                            ></path>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(47.6558277027027,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Wed 07</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(61.96748310810811,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Fri 09</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(76.27913851351352,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Apr 11</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(90.59079391891892,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Tue 13</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(104.90244932432434,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Thu 15</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(119.21410472972974,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Sat 17</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(133.52576013513513,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Mon 19</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(147.83741554054055,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Wed 21</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(162.14907094594594,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Fri 23</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(176.46072635135133,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Apr 25</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(190.77238175675674,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Tue 27</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(205.08403716216216,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Thu 29</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(219.39569256756755,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">May</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(233.70734797297297,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Mon 03</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(248.01900337837836,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Wed 05</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(262.3306587837838,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Fri 07</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(276.64231418918916,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">May 09</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(290.95396959459464,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Tue 11</text>
                            </g>
                            <g
                              class="tick"
                              opacity="1"
                              transform="translate(305.265625,0)"
                            >
                              <line stroke="#000" y2="0"></line>
                              <text fill="#000" y="3" dy="0.71em">Thu 13</text>
                            </g>
                          </g>
                          <path
                            fill="none"
                            stroke-width="2"
                            stroke="#fff"
                            d="M40,142C40,142,44.7705518018018,40.399999999999984,47.1558277027027,40.39999999999999C49.541103603603595,40.39999999999999,46.69841508680974,134.90411098679147,54.3116554054054,142C56.32962847406076,143.88084341589044,59.08220720720721,141.99999999999997,61.46748310810811,142C63.852759009009006,142,66.2380349099099,142,68.6233108108108,142C71.00858671171171,142,73.76116544485815,143.88084341589044,75.77913851351352,142C83.39237883210919,134.90411098679147,66.93756219772189,47.961916919307406,82.93496621621622,40.39999999999999C101.12154521956442,31.803267723266284,170.51988147734804,110.30161273325989,190.27238175675674,116.60000000000001C196.78538660003292,118.67677135516209,200.63198264954278,116.60000000000004,204.58403716216216,116.60000000000001C207.37856170765423,116.6,209.354588963964,116.60000000000004,211.7398648648649,116.60000000000001C214.12514076576582,116.60000000000004,216.89818432040164,118.4187137296444,218.89569256756755,116.60000000000001C225.42834303409745,110.65207907837026,223.6662443693694,40.39999999999999,226.0515202702703,40.39999999999999C228.43679617117115,40.39999999999999,224.78565892111183,108.93212602393635,233.20734797297297,116.60000000000001C236.84912506321552,119.91580608176514,244.02669065258618,119.2443843434444,247.51900337837836,116.60000000000001C252.26117820190157,113.00921823392656,250.84599532543075,94.09920007766917,254.6748310810811,91.2C256.66865731114785,89.69027183980455,259.836832553717,89.69027183980457,261.8306587837838,91.2C265.6594945394342,94.09920007766918,266.6012105855856,116.60000000000001,268.9864864864865,116.60000000000001C271.3717623873874,116.6,273.75703828828824,91.2,276.14231418918916,91.2C278.52759009009003,91.19999999999999,281.1945937621053,116.74185268166951,283.2981418918919,116.60000000000001C286.2311157820687,116.40221502627065,288.0686936936938,65.80000000000003,290.45396959459464,65.80000000000001C292.8392454954956,65.80000000000001,295.51194936376015,116.67306268156885,297.60979729729735,116.60000000000001C300.5657195152615,116.49705278428392,304.765625,15,304.765625,15"
                          ></path>
                          <circle
                            cx="40"
                            cy="142"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="47.1558277027027"
                            cy="40.39999999999999"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="54.3116554054054"
                            cy="142"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="61.46748310810811"
                            cy="142"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="68.6233108108108"
                            cy="142"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="75.77913851351352"
                            cy="142"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="82.93496621621622"
                            cy="40.39999999999999"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="190.27238175675674"
                            cy="116.60000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="204.58403716216216"
                            cy="116.60000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="211.7398648648649"
                            cy="116.60000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="218.89569256756755"
                            cy="116.60000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="226.0515202702703"
                            cy="40.39999999999999"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="233.20734797297297"
                            cy="116.60000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="247.51900337837836"
                            cy="116.60000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="254.6748310810811"
                            cy="91.2"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="261.8306587837838"
                            cy="91.2"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="268.9864864864865"
                            cy="116.60000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="276.14231418918916"
                            cy="91.2"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="283.2981418918919"
                            cy="116.60000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="290.45396959459464"
                            cy="65.80000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="297.60979729729735"
                            cy="116.60000000000001"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="304.765625"
                            cy="15"
                            r="4"
                            fill="#1da8ce"
                          ></circle>
                          <circle
                            cx="40"
                            cy="142"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="47.1558277027027"
                            cy="40.39999999999999"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="54.3116554054054"
                            cy="142"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="61.46748310810811"
                            cy="142"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="68.6233108108108"
                            cy="142"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="75.77913851351352"
                            cy="142"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="82.93496621621622"
                            cy="40.39999999999999"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="190.27238175675674"
                            cy="116.60000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="204.58403716216216"
                            cy="116.60000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="211.7398648648649"
                            cy="116.60000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="218.89569256756755"
                            cy="116.60000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="226.0515202702703"
                            cy="40.39999999999999"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="233.20734797297297"
                            cy="116.60000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="247.51900337837836"
                            cy="116.60000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="254.6748310810811"
                            cy="91.2"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="261.8306587837838"
                            cy="91.2"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="268.9864864864865"
                            cy="116.60000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="276.14231418918916"
                            cy="91.2"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="283.2981418918919"
                            cy="116.60000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="290.45396959459464"
                            cy="65.80000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="297.60979729729735"
                            cy="116.60000000000001"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                          <circle
                            cx="304.765625"
                            cy="15"
                            r="10"
                            fill="rgba(0, 0, 0, 0)"
                          ></circle>
                        </svg>
                      </div>
                      <div
                        data-v-8b815544=""
                        class="admin_dashboard__card__title"
                      >
                        {{ $t('forum_new_users_past_week') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
                v-show="isGeneral"
              >
                <div class="w-100 border-bottom border-green-lighter mb-3">
                  <h3 class="display-4">{{ $t('forum_general') }}</h3>
                </div>
                <div
                  class="card form-group bg-gray-900 box-shadow border border-green-lighter p-3 my-3"
                >
                  <span class="h4 mb-0">Forum info</span>
                  <form class="form-group">
                    <div class="d-flex flex-row flex-wrap">
                      <input
                        type="text"
                        class="col-lg-6 form-control mr-sm-3 mt-3"
                        aria-label="Thread title input"
                        aria-describedby="inputGroup-sizing-default"
                        placeholder="Forum alias"
                        required
                      />
                      <input
                        type="text"
                        class="col-lg-6 form-control mr-sm-3 mt-3"
                        aria-label="Thread title input"
                        aria-describedby="inputGroup-sizing-default"
                        placeholder="Forum description"
                      />
                    </div>
                    <div class="custom-control custom-switch mt-3">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="show-description-switch"
                      />
                      <label
                        class="custom-control-label"
                        for="show-description-switch"
                        >Show forum description on homepage</label
                      >
                    </div>
                    <div>
                      <button
                        class="btn btn-outline-primary mt-3"
                        type="submit"
                      >
                        Save settings
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  class="card bg-gray-900 box-shadow border border-green-lighter p-3 my-3"
                >
                  <span class="h4">{{ $t('forum_categories') }}</span>
                  <span>Hover to remove or edit a category.</span>
                  <span
                    >Removing a category will place any threads in that category
                    into 'Other'</span
                  >
                  <div class="d-flex flex-row flex-wrap mt-3">
                    <div
                      class="d-flex flex-row flex-nowrap border rounded p-2 mr-2"
                    >
                      <span class="color-dot bg-primary rounded-circle"></span>
                      <span>{{ $t('forum_general') }} discussion</span>
                    </div>
                    <div
                      class="d-flex flex-row flex-nowrap border rounded p-2 mr-2"
                    >
                      <span
                        class="color-dot bg-secondary rounded-circle"
                      ></span>
                      <span>Hot gameplay</span>
                    </div>
                  </div>
                  <div class="d-flex flex-row flex-wrap mt-3">
                    <button
                      class="btn btn-outline-primary btn-sm d-flex flex-row flex-nowrap align-items-center-justify-content-center"
                      data-toggle="modal"
                      data-target="#CategoryModal"
                    >
                      <span><i class="fas fa-plus mr-2"></i></span>
                      <span>Add a new category</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="moderation"
                role="tabpanel"
                aria-labelledby="moderation-tab"
                v-show="isModeration"
              >
                <div class="w-100 border-bottom border-green-lighter mb-3">
                  <h3 class="display-4">Moderation</h3>
                </div>
                <div class="d-flex flex-column">
                  <ul
                    class="nav-thread-list nav nav-tabs justify-content-sm-start"
                    role="tablist"
                  >
                    <li class="nav-item d-flex">
                      <a
                        id="post-tab"
                        class="nav-link h6 active text-shadow mb-0"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="post"
                        aria-selected="true"
                        >Reports</a
                      >
                    </li>
                    <li class="nav-item d-flex">
                      <a
                        id="thread-tab"
                        class="nav-link h6 text-shadow mb-0"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="thread"
                        aria-selected="true"
                        >{{ $t('forum_banned_users') }}</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="col-12 p-0 d-flex flex-column tab-content mb-5">
                  <div
                    class="tab-pane fade show active"
                    id="post"
                    role="tabpanel"
                    aria-labelledby="post-tab"
                  >
                    <!--Reports-->
                    <div
                      class="card bg-gray-900 box-shadow border border-green-lighter p-3 my-3"
                    >
                      <span>{{ $t('forum_some_content') }}</span>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="thread"
                    role="tabpanel"
                    aria-labelledby="thread-tab"
                  >
                    <!--Banned users-->
                    <div
                      class="card bg-gray-900 box-shadow border border-green-lighter p-3 my-3"
                    >
                      <span>{{ $t('forum_other_content') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="users"
                role="tabpanel"
                aria-labelledby="users-tab"
                v-show="isUsers"
              >
                <div class="w-100 border-bottom border-green-lighter mb-3">
                  <h3 class="display-4">users</h3>
                </div>
                <div class="d-flex flex-column">
                  <div
                    class="col-12 card bg-gray-900 box-shadow border border-green-lighter p-3 my-3"
                  >
                    <span class="h4 mb-0">{{ $t("forum_filter_users") }}</span>
                    <form>
                      <div class="d-flex flex-md-row flex-column">
                        <div class="col mt-3 pl-0 pr-md-2 pr-0">
                          <input
                            type="text"
                            class="form-control"
                            :placeholder='`${ $t("forum_filter_users") }`'
                          />
                        </div>
                        <div class="col mt-3 pr-0 pl-md-2 pl-0">
                          <div
                            class="selectCategoryDropdown d-flex align-items-center border-primary border dropdown px-3"
                          >
                            <span
                              class="dropdown-toggle"
                              id="UserCategoryDropdown"
                              role="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {{ $t('forum_select_category') }}
                            </span>
                            <div
                              class="dropdown-menu border border-green-lighter"
                              aria-labelledby="UserCategoryDropdown"
                            >
                              <div
                                class="dropdown-item text-white fontPrimary custom-control custom-radio mx-3"
                              >
                                <input
                                  type="checkbox"
                                  checked
                                  id="Super"
                                  name="userCategory"
                                  class="custom-control-input"
                                />
                                <label class="custom-control-label" for="Super"
                                  >{{ $t('forum_super') }}</label
                                >
                              </div>
                              <div
                                class="dropdown-divider border-green-lighter"
                              ></div>
                              <div
                                class="dropdown-item text-white fontPrimary custom-control custom-radio mx-3"
                              >
                                <input
                                  type="checkbox"
                                  checked
                                  id="Admin"
                                  name="userCategory"
                                  class="custom-control-input"
                                />
                                <label class="custom-control-label" for="Admin"
                                  >{{ $t('forum_admin') }}</label>
                              </div>
                              <div
                                class="dropdown-divider border-green-lighter"
                              ></div>
                              <div
                                class="dropdown-item text-white fontPrimary custom-control custom-radio mx-3"
                              >
                                <input
                                  type="checkbox"
                                  checked
                                  id="Moderator"
                                  name="userCategory"
                                  class="custom-control-input"
                                />
                                <label
                                  class="custom-control-label"
                                  for="Moderator"
                                  >{{ $t('forum_moderator') }}</label
                                >
                              </div>
                              <div
                                class="dropdown-divider border-green-lighter"
                              ></div>
                              <div
                                class="dropdown-item text-white fontPrimary custom-control custom-radio mx-3"
                              >
                                <input
                                  type="checkbox"
                                  checked
                                  id="User"
                                  name="userCategory"
                                  class="custom-control-input"
                                />
                                <label class="custom-control-label" for="User"
                                  >User</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <table
                    class="table-responsive-md bg-gray-900 box-shadow table table-hover my-3"
                  >
                    <thead>
                      <tr>
                        <th
                          class="border-green-lighter border-bottom-0 font-weight-normal dropdown h6"
                        >
                          <span
                            class="dropdown-toggle"
                            id="dateDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {{ $t('forum_username') }}
                          </span>
                          <div
                            class="dropdown-menu border border-green-lighter"
                            aria-labelledby="dateDropdown"
                          >
                            <div class="dropdown-item text-white fontPrimary">
                              {{ $t('forum_ascending') }}
                            </div>
                            <div
                              class="dropdown-divider border-green-lighter"
                            ></div>
                            <div class="dropdown-item text-white fontPrimary">
                              {{ $t('forum_descending') }}
                            </div>
                          </div>
                        </th>
                        <th
                          class="border-green-lighter border-bottom-0 font-weight-normal h6"
                        >
                          {{ $t('forum_creation_date') }}
                        </th>
                        <th
                          class="border-green-lighter border-bottom-0 font-weight-normal dropdown h6"
                        >
                          <span
                            class="dropdown-toggle"
                            id="dateDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Account created at
                          </span>
                          <div
                            class="dropdown-menu border border-green-lighter"
                            aria-labelledby="dateDropdown"
                          >
                            <div class="dropdown-item text-white fontPrimary">
                              {{ $t('forum_ascending') }}
                            </div>
                            <div
                              class="dropdown-divider border-green-lighter"
                            ></div>
                            <div class="dropdown-item text-white fontPrimary">
                              {{ $t('forum_descending') }}
                            </div>
                          </div>
                        </th>
                        <th
                          class="border-green-lighter border-bottom-0 font-weight-normal dropdown h6"
                        >
                          <span
                            class="dropdown-toggle"
                            id="postDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {{ $t("forum_post_count") }}
                          </span>
                          <div
                            class="dropdown-menu border border-green-lighter"
                            aria-labelledby="postDropdown"
                          >
                            <div class="dropdown-item text-white fontPrimary">
                              {{ $t('forum_ascending') }}
                            </div>
                            <div
                              class="dropdown-divider border-green-lighter"
                            ></div>
                            <div class="dropdown-item text-white fontPrimary">
                              {{ $t('forum_descending') }}
                            </div>
                          </div>
                        </th>
                        <th
                          class="border-green-lighter border-bottom-0 font-weight-normal dropdown h6"
                        >
                          <span
                            class="dropdown-toggle"
                            id="threadDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Threads {{ $t("forum_count") }}
                          </span>
                          <div
                            class="dropdown-menu border border-green-lighter"
                            aria-labelledby="threadDropdown"
                          >
                            <div class="dropdown-item text-white fontPrimary">
                              {{ $t('forum_ascending') }}
                            </div>
                            <div
                              class="dropdown-divider border-green-lighter"
                            ></div>
                            <div class="dropdown-item text-white fontPrimary">
                              {{ $t('forum_descending') }}
                            </div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="border-green-lighter">
                          <a href="">
                            <img
                              v-bind:src="avatar_img"
                              class="img-user-small mr-2 mb-1"
                              alt=""
                            />
                            <span class="text-white">User name 2</span>
                          </a>
                        </td>
                        <td class="border-green-lighter">
                          <div
                            class="edit-role-button-container d-flex flex-row"
                          >
                            <span>User</span>
                            <button
                              class="btn btn-link btn-sm text-white edit-role-button"
                            >
                              <i class="text-white fas fa-edit ml-2"></i>
                            </button>
                          </div>
                          <div
                            class="edit-role flex-row align-items-center d-none"
                          >
                            <select
                              class="border-secondary text-white bg-gray-900 py-1 mr-2"
                            >
                              <option selected>User</option>
                              <option value="1">{{ $t('forum_super') }}</option>
                              <option value="2">{{ $t('forum_admin') }}</option>
                              <option value="3">{{ $t('forum_moderator') }}</option>
                            </select>
                            <button class="btn btn-link btn-sm text-white">
                              <i class="fas fa-check mx-2"></i>
                            </button>
                            <button
                              class="btn-close btn btn-link btn-sm text-white"
                            >
                              <i class="fas fa-times mx-2"></i>
                            </button>
                          </div>
                        </td>
                        <td class="border-green-lighter">12/04/2021</td>
                        <td class="border-green-lighter">1</td>
                        <td class="border-green-lighter">1</td>
                      </tr>
                      <tr>
                        <td class="border-green-lighter">
                          <a href="">
                            <img
                              v-bind:src="avatar_img"
                              class="img-user-small mr-2 mb-1"
                              alt=""
                            />
                            <span class="text-white">User name 2</span>
                          </a>
                        </td>
                        <td class="border-green-lighter">
                          <div
                            class="edit-role-button-container d-flex flex-row"
                          >
                            <span>User</span>
                            <button
                              class="btn btn-link btn-sm text-white edit-role-button"
                            >
                              <i class="text-white fas fa-edit ml-2"></i>
                            </button>
                          </div>
                          <div
                            class="edit-role flex-row align-items-center d-none"
                          >
                            <select
                              class="border-secondary text-white bg-gray-900 py-1 mr-2"
                            >
                              <option selected>User</option>
                              <option value="1">{{ $t('forum_super') }}</option>
                              <option value="2">{{ $t('forum_admin') }}</option>
                              <option value="3">{{ $t('forum_moderator') }}</option>
                            </select>
                            <button class="btn btn-link btn-sm text-white">
                              <i class="fas fa-check mx-2"></i>
                            </button>
                            <button
                              class="btn-close btn btn-link btn-sm text-white"
                            >
                              <i class="fas fa-times mx-2"></i>
                            </button>
                          </div>
                        </td>
                        <td class="border-green-lighter">12/04/2021</td>
                        <td class="border-green-lighter">1</td>
                        <td class="border-green-lighter">1</td>
                      </tr>
                      <tr>
                        <td class="border-green-lighter">
                          <a href="">
                            <img
                              v-bind:src="avatar_img"
                              class="img-user-small mr-2 mb-1"
                              alt=""
                            />
                            <span class="text-white">User name 2</span>
                          </a>
                        </td>
                        <td class="border-green-lighter">
                          <div
                            class="edit-role-button-container d-flex flex-row"
                          >
                            <span>User</span>
                            <button
                              class="btn btn-link btn-sm text-white edit-role-button"
                            >
                              <i class="text-white fas fa-edit ml-2"></i>
                            </button>
                          </div>
                          <div
                            class="edit-role flex-row align-items-center d-none"
                          >
                            <select
                              class="border-secondary text-white bg-gray-900 py-1 mr-2"
                            >
                              <option selected>User</option>
                              <option value="1">{{ $t('forum_super') }}</option>
                              <option value="2">{{ $t('forum_admin') }}</option>
                              <option value="3">{{ $t('forum_moderator') }}</option>
                            </select>
                            <button class="btn btn-link btn-sm text-white">
                              <i class="fas fa-check mx-2"></i>
                            </button>
                            <button
                              class="btn-close btn btn-link btn-sm text-white"
                            >
                              <i class="fas fa-times mx-2"></i>
                            </button>
                          </div>
                        </td>
                        <td class="border-green-lighter">12/04/2021</td>
                        <td class="border-green-lighter">1</td>
                        <td class="border-green-lighter">1</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FancyTextarea from "../FancyTextarea";
import LoadingButton from "../LoadingButton";
import ModalWindow from "../ModalWindow";
import ConfirmModal from "../ConfirmModal";

import AjaxErrorHandler from "../../assets/js/errorHandler";
import logger from "../../assets/js/logger";

export default {
  name: "settingsGeneral",
  components: {
    FancyTextarea,
    LoadingButton,
    ModalWindow,
    ConfirmModal,
  },
  data() {
    return {
      description: {
        value: "",
        loading: false,
        error: "",
      },

      picture: {
        current: null,
        showProfilePictureModal: false,
        showRemoveProfilePictureModal: false,
        dragging: false,
        dataURL: null,
        file: null,
        loading: false,
      },

      avatar_img: require("./../../assets/img/default/bg-artwork.jpg"),
      isDashboard: true,
      isGeneral: false,
      isModeration: false,
      isUsers: false,

      // showDashboard(){
      //   this.isDashboard= true 
      // },
      // showGeneral(){
      //   this.isGeneral= true 
      // }
    };
  },
  computed: {},
  methods: {
    saveDescription() {
      this.description.error = "";
      this.description.loading = true;

      this.axios
        .put("/api/v1/user/" + this.$store.state.username, {
          description: this.description.value,
        })
        .then(() => {
          this.description.loading = false;
        })
        .catch((e) => {
          this.description.loading = false;

          AjaxErrorHandler(this.$store)(e, (error) => {
            this.description.error = error.message;
          });
        });
    },
    uploadProfilePicture() {
      this.picture.loading = true;

      let formData = new FormData();
      formData.append("picture", this.picture.file);

      this.axios
        .post(
          "/api/v1/user/" + this.$store.state.username + "/picture",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          this.hideProflePictureModal();
          this.picture.current = res.data.picture;
        })
        .catch((e) => {
          this.picture.loading = false;

          AjaxErrorHandler(this.$store)(e);
        });
    },
    removeProfilePicture() {
      this.axios
        .delete("/api/v1/user/" + this.$store.state.username + "/picture")
        .then(() => {
          this.picture.current = null;
        })
        .catch(AjaxErrorHandler(this.$store));
    },
    hideProflePictureModal() {
      this.picture.showProfilePictureModal = false;

      //Wait for transition to complete
      setTimeout(() => {
        this.picture.dataURL = null;
        this.picture.loading = false;
      }, 200);
    },
    handleDragOver(e) {
      e.preventDefault();
      this.picture.dragging = true;
    },
    handleFileDrop(e) {
      e.preventDefault();
      this.picture.dragging = false;

      if (e.dataTransfer && e.dataTransfer.items) {
        let file = e.dataTransfer.items[0];

        if (file.type.match("^image/")) {
          this.processImage(file.getAsFile());
        }
      }
    },
    processImage(file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);

      this.picture.file = file;

      reader.addEventListener("load", () => {
        this.picture.dataURL = reader.result;
      });
    },
    
  },
  created() {
    this.$store.dispatch("setTitle", "general settings");

    this.$nextTick(() => {
      this.axios
        .get("/api/v1/user/" + this.$store.state.username)
        .then((res) => {
          this.description.value = res.data.description || "";
          this.picture.current = res.data.picture;
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e);
        });
    });

    logger("settingsGeneral");
  },
};
</script>

<style lang='scss' scoped>
@import "../../assets/scss/variables.scss";
.container {
  margin: auto;
}

.profile_picture_preview {
  height: 5rem;
  width: 5rem;
}

.profile_picture_modal {
  padding-top: 1rem;
  transition: all 0.2s;

  @at-root #{&}--picture .dragging {
    background-color: $color__lightgray--primary;
  }

  @at-root #{&}__overlay {
    @include loading-overlay(rgba(0, 0, 0, 0.5), 0.125rem);
  }

  @at-root #{&}__upload_button input[type="file"] {
    display: none;
  }

  @at-root #{&}__drag_area {
    padding: 1rem;
    text-align: center;

    @at-root #{&}__image {
      width: 5rem;
      height: 5rem;
      display: inline-block;
      margin-top: -1rem;
    }

    @at-root #{&}__icon {
      font-size: 6rem;
      color: $color__gray--darker;
      transition: all 0.2s;

      @at-root #{&}--picture.dragging {
        transform: translateY(-0.5rem) scale(1.1);
        color: $color__gray--darkest;
      }
    }
  }
}

@media (max-width: $breakpoint--tablet) {
  .h1 {
    display: none;
  }
}
</style>
